import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track15CRed = ({ state, workState, onLabelClick }) => (
	<g id="Track15CRed" transform="translate(2174.000000, 946.000000)" className="track">
		<path
			d="M101.429689,109 L118.21984,78.4116954 C126.192346,63.8873796 120.881054,45.6501022 106.356739,37.6775962 C106.234006,37.610227 106.110802,37.5437178 105.987138,37.4780736 L51.855984,8.74383765 M42.4101649,4.33599087 C29.2626757,-2.26802203 13.396479,-0.0130320744 2.60965063,9.99265587 L-3.63797881e-12,12.4133257 L-3.63797881e-12,12.4133257"
			stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)} strokeWidth={tracksWidth}
			strokeLinecap="round"/>

		<TrackArrow
			transform="translate(54.976742, 10.280205) rotate(-328.000000) translate(-54.976742, -10.280205) "
			points="58.9767423 18.2802047 50.9767423 10.2802047 58.9767423 2.2802047"
			strokeColor={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track15CRed')}
			coords="92.976539, 28.251704"
			text="15C"
			textCoordsX="7.55566406"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>
);

Track15CRed.propTypes = trackPropTypes;
export default Track15CRed;
